import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { SITE } from "@/constants/site";
import { scrollToId } from "@/lib/scroll";

const links = [
  { label: "Services", id: "services" },
  { label: "Gallery", id: "gallery" },
  { label: "Pricing", id: "pricing" },
  { label: "Reviews", id: "reviews" },
];

export const Nav = () => (
  <header data-testid="site-nav" className="fixed top-0 z-50 w-full border-b border-seam bg-ink">
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
      <button
        data-testid="nav-logo"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="font-display text-2xl font-black italic uppercase leading-none tracking-tighter"
      >
        <span className="text-white">Take The</span>{" "}
        <span className="text-acid">Leap</span>
        <span className="ml-2 hidden align-middle text-[10px] font-bold not-italic tracking-[0.3em] text-zinc-500 sm:inline">
          Junk Removal
        </span>
      </button>

      <nav className="hidden items-center gap-8 lg:flex">
        {links.map((l) => (
          <button
            key={l.id}
            data-testid={`nav-link-${l.id}`}
            onClick={() => scrollToId(l.id)}
            className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-400 transition-colors duration-200 hover:text-acid"
          >
            {l.label}
          </button>
        ))}
        <Link
          data-testid="nav-link-areas"
          to="/service-areas"
          className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-400 transition-colors duration-200 hover:text-acid"
        >
          Areas
        </Link>
      </nav>

      <div className="flex items-center gap-3">
        <a
          data-testid="nav-call-btn"
          href={`tel:${SITE.phoneTel}`}
          className="hidden items-center gap-2 border border-seam px-4 py-2.5 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-200 hover:border-acid hover:text-acid sm:flex"
        >
          <Phone className="h-3.5 w-3.5" />
          {SITE.phoneDisplay}
        </a>
        <button
          data-testid="nav-quote-btn"
          onClick={() => scrollToId("quote")}
          className="bg-acid px-5 py-2.5 font-display text-lg font-extrabold italic uppercase tracking-tight text-black transition-colors duration-200 hover:bg-white"
        >
          Free Quote
        </button>
      </div>
    </div>
  </header>
);
